import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["personas"]
  static values = { personasUrl: String }

  canvasChanged(event) {
    const canvasId = event.target.value

    if (!canvasId) {
      this.personasTarget.innerHTML = ""
      return
    }

    const url = new URL(this.personasUrlValue, window.location.origin)
    url.searchParams.set("canvas_id", canvasId)

    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      }
    })
      .then((response) => response.text())
      .then((html) => {
        this.personasTarget.innerHTML = html
      })
  }
}
